export default "__VITE_ASSET__51139b11__"